








































import { RouterNames } from "@/router/routernames";
import { cajasDto } from "@/shared/dtos/cajasDto";
import { Component, Vue } from "vue-property-decorator";
import TiendaService from "@/shared/services/TiendaService";
import Dynamic_table from "../dynamic_tables/dynamic_table.vue";
import productoModule from "@/store/modules/producto-module";
import { API } from "@/shared/api";

@Component({
  components: {
    Dynamic_table,
  },
})
export default class CajasLista extends Vue {
  private dialog: boolean = false;
  private categoria_seleccionada: Array<{ id: number; name: string }> = [];
  private caja_selecionada: any = {};
  public categorias: any[] = [];
  async created() {
    this.categorias = await TiendaService.obtenerCategorias();
    var items = this.categorias.map((item) => {
      return {
        id: item.id,
        name: item.name,
      };
    });
    // console.log("categorias", items);
  }

  asignarCategoriaPorDepartamento(departamento: string): {
    id: number;
    name: string;
  } {
    switch (departamento) {
      case "Kitchen":
      case "Home":
        return this.categorias_local.find((c) => c.name === "Hogar")!;
      case "Major Appliances":
        return this.categorias_local.find(
          (c) => c.name === "Electrodomésticos"
        )!;
      case "Wireless":
      case "PC":
      case "Home Entertainment":
      case "Musical Instruments":
      case "Electronics":
      case "Office Product":
      case "Camera":
      case "DVD":
      case "Software":
        return this.categorias_local.find(
          (c) => c.name === "Electrónica, sonido y oficina"
        )!;
      case "Toy":
        return this.categorias_local.find((c) => c.name === "Juguetes")!;
      case "Personal Care Appliances":
        return this.categorias_local.find(
          (c) => c.name === "Bebé y cuidado personal"
        )!;
      case "Pet Products":
      case "Luggage":
        return this.categorias_local.find((c) => c.name === "Sin categorizar")!;
      case "Lawn and Garden":
      case "Furniture":
        return this.categorias_local.find(
          (c) => c.name === "Muebles y jardín"
        )!;
      case "Sports":
        return this.categorias_local.find((c) => c.name === "Ropa y deporte")!;
      case "BISS":
        return this.categorias_local.find((c) => c.name === "Herramientas")!;
      default:
        return this.categorias_local.find((c) => c.name === "Sin categorizar")!;
    }
  }

  public categorias_local = [
    { id: 19, name: "Bebé y cuidado personal" },
    { id: 18, name: "Cajas Sorpresa" },
    { id: 21, name: "Electrodomésticos" },
    { id: 23, name: "Electrónica, sonido y oficina" },
    { id: 20, name: "Herramientas" },
    { id: 24, name: "Hogar" },
    { id: 22, name: "Juguetes" },
    { id: 25, name: "Muebles y jardín" },
    { id: 26, name: "Ropa y deporte" },
    { id: 15, name: "Sin categorizar" },
  ];

  editar_caja(obj: cajasDto) {
    this.$router.push({
      name: RouterNames.cajasstockformulario,
      params: { id: "23", caja: obj.localizador },
    });
  }

  subir_todas_las_cajas() {
    productoModule.getcajas().then(() => {
      for (const caja of productoModule.cajas) {
        if (caja.vendida || caja.abierta) {
          console.log("caja vendida o abierta", caja.localizador);
          continue;
        }
        try {
          const categoria = this.asignarCategoriaPorDepartamento(
            caja.department
          );
          try {
            this.categoria_seleccionada = [
              { id: categoria.id, name: categoria.name },
            ];

            console.log("categoria", this.categoria_seleccionada);
            TiendaService.crearProducto(caja, this.categoria_seleccionada).then(
              () => {
                console.log("caja creada:", caja.localizador);
              }
            );
          } catch (error) {
            console.error("Error al crear la caja:", caja.localizador, error);
          }
        } catch (error) {
          console.error("Error al crear la caja:", caja.localizador, error);
        }
      }
    });
  }

  async crearProducto(item: any) {
    this.dialog = true;
    this.caja_selecionada = item;
  }

  crearImagen(item: any) {
    productoModule.crearImagen(item.localizador).then(() => {
      window.open(
        API.webApiBaseImagenes + "1/" + item.localizador + ".png",
        "_blank"
      );
    });
  }

  seleccionarCategoria(id: number, nombre: string): void {
    this.dialog = false;
    this.categoria_seleccionada = [{ id, name: nombre }];

    TiendaService.crearProducto(
      this.caja_selecionada,
      this.categoria_seleccionada
    );
  }
}
